import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Loan } from 'types'

interface LoanFlowState {
  data: Loan | null,
}

const initialState: LoanFlowState = {
  data: null,
}

export const loanFlowSlice = createSlice({
  name: 'loanFlow',
  initialState,
  reducers: {
    setLoanData: (state, action: PayloadAction<Loan>) => {
      state.data = action.payload
    },
    clearLoanData: (state) => {
      state.data = null
    },
  },
})

export const { setLoanData, clearLoanData } = loanFlowSlice.actions
export default loanFlowSlice.reducer
